import axios from "axios";
import Cookies from "universal-cookie";
import { COMPANY_ID, TOKEN_NAME, config } from "../config";

const cookies = new Cookies();

const getAuthHeaders = () => {
  const token = cookies.get(TOKEN_NAME);
  return {
    Authorization: token ? `Bearer ${token}` : "",
  };
};

export const getAttendanceAndLeavesStatistics = async (data = {}) => {
  const formData = new FormData();
  
  if (!data.company_id && cookies.get(COMPANY_ID)) {
    formData.append("company_id", cookies.get(COMPANY_ID));
  }

  Object.keys(data).forEach((key) => {
    if (data[key] !== undefined && data[key] !== null) {
      formData.append(key, data[key]);
    }
  });

  const res = await axios({
    method: "POST",
    url: `${config.apiurl}attendance_and_leaves_statistics`,
    data: formData,
    headers: getAuthHeaders(),
  });
  return res;
};

export const getPayrollStatistics = async (data = {}) => {
  const formData = new FormData();

  if (!data.company_id && cookies.get(COMPANY_ID)) {
    formData.append("company_id", cookies.get(COMPANY_ID));
  }

  Object.keys(data).forEach((key) => {
    if (data[key] !== undefined && data[key] !== null) {
      formData.append(key, data[key]);
    }
  });

  const res = await axios({
    method: "POST",
    url: `${config.apiurl}payroll_statistics`,
    data: formData,
    headers: getAuthHeaders(),
  });
  return res;
};

export const getApplicationSettingsOverview = async (data = {}) => {
  const formData = new FormData();

  if (!data.company_id && cookies.get(COMPANY_ID)) {
    formData.append("company_id", cookies.get(COMPANY_ID));
  }

  Object.keys(data).forEach((key) => {
    if (data[key] !== undefined && data[key] !== null) {
      formData.append(key, data[key]);
    }
  });

  const res = await axios({
    method: "POST",
    url: `${config.apiurl}application_settings_overview`,
    data: formData,
    headers: getAuthHeaders(),
  });
  return res;
};
